import React from "react";

import { Filter } from "../../../components/FilterChips/FilterChips";
import { WorkflowDetailsTodoFilters } from "./WorkflowDetailsFilterPanel";

import ReadableFilterChipsShell from "../ReadableFilterChipsShell";
import { describeDateRange } from "../dateFormatting";
import { DETAIL_TODO_STATUS_OPTIONS } from "./statuses";

export const convertWorkflowDetailsFiltersToReadableList = (filters: Partial<WorkflowDetailsTodoFilters>): Filter[] => {
	const readableList: Filter[] = [];

	if (filters.assignee) {
		readableList.push({
			id: "assignee",
			type: "single-employee",
			label: "Assignee",
			value: { id: filters.assignee.id, name: filters.assignee.name },
		});
	}

	if (filters.status) {
		readableList.push({
			id: "status",
			type: "string",
			label: "Status",
			value:
				DETAIL_TODO_STATUS_OPTIONS.find((option) => option.value === filters.status)?.label ?? filters.status,
		});
	}

	if (filters.dueDateStart || filters.dueDateEnd) {
		readableList.push({
			id: "dueDate",
			type: "string",
			label: "Due Date",
			value: describeDateRange(filters.dueDateStart, filters.dueDateEnd),
		});
	}

	if ((filters.hasSignatureRequest?.length ?? 0) > 0) {
		readableList.push({
			id: "hasSignatureRequest",
			type: "string",
			label: "Has Signature Request",
			value: "Yes",
		});
	}

	return readableList;
};

const CHIP_ID_TO_FILTER_KEYS: Record<string, (keyof WorkflowDetailsTodoFilters)[]> = {
	dueDate: ["dueDateStart", "dueDateEnd"],
};

type ReadableWorkflowDetailsFilterChipsProps = {
	filters: Partial<WorkflowDetailsTodoFilters>;
	setFilters: (newFilters: Partial<WorkflowDetailsTodoFilters>) => void;
};

const ReadableWorkflowDetailsFilterChips = ({ filters, setFilters }: ReadableWorkflowDetailsFilterChipsProps) => (
	<ReadableFilterChipsShell<WorkflowDetailsTodoFilters>
		filters={filters}
		setFilters={setFilters}
		convert={convertWorkflowDetailsFiltersToReadableList}
		chipIdToFilterKeys={CHIP_ID_TO_FILTER_KEYS}
	/>
);

export default ReadableWorkflowDetailsFilterChips;
